module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/NFLplayer-02ef717d57af4a491135d2ad04ec78ec.svg";